import React from 'react';
import {CopySection} from 'presentation/components';
import {CopySectionMaskEnum} from 'presentation/constants';
import {Stack, Typography, useTheme} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {PasswordSectionProps} from '../types';

const {passwordSection} = translations['pt-br'].privateFlow.requestAuthorizations;

export function PasswordSection({validate, password}: PasswordSectionProps) {
	const {colors} = useTheme();

	return (
		<Stack gap={'4px'}>
			<Stack justifyContent="space-between" alignItems="center" direction="row" gap={2}>
				{password ? (
					<Stack gap={1} direction="row">
						<Icon name="password-default" size={'20px'} color={colors.brand.primary.blue} />
						<Typography>{passwordSection.password}</Typography>
					</Stack>
				) : null}

				{validate ? (
					<Typography variant="helperText" fontWeight={600} color="#CC6302" ml="auto">
						{passwordSection.validate} {validate}
					</Typography>
				) : null}
			</Stack>

			{password ? (
				<CopySection
					customPadding="8px 16px"
					mask={CopySectionMaskEnum.WITHOUT_MASK}
					value={password}
					snackbarMessage={passwordSection.snackbarMessage}
					highlightedIcons
					dataTagId={{ copy: AutoSolEnum.AS_CLICK_COPIAR_SENHA }}
				/>
			) : null}
		</Stack>
	);
}
